import { useState } from 'react'
import { supabase } from '../../../../lib/supabase'

const CLUB_ID = 'a0000000-0000-0000-0000-000000000001'

export default function PaymentForm({ member, settings, onClose, onRefresh }) {
  const defaultAmount = settings.member_subscription_fee || '50'
  const currency = settings.currency || 'ZMW'

  const existingSubscription = member.subscriptions && member.subscriptions.length > 0
    ? member.subscriptions.sort((a, b) => new Date(b.payment_date) - new Date(a.payment_date))[0]
    : null

  const getValidUntil = () => {
    if (settings.season_end_date) return settings.season_end_date
    const date = new Date()
    date.setMonth(date.getMonth() + 12)
    return date.toISOString().split('T')[0]
  }

  const [formData, setFormData] = useState({
    amount: existingSubscription?.amount || defaultAmount,
    payment_method: existingSubscription?.payment_method || 'cash',
    transaction_ref: '',
    payment_date: new Date().toISOString().split('T')[0],
    valid_until: getValidUntil(),
  })
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const isUpdate = !!existingSubscription

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    setError(null)

    const payload = {
      supporter_id: member.id,
      club_id: CLUB_ID,
      amount: Number(formData.amount),
      payment_date: formData.payment_date,
      valid_until: formData.valid_until,
      status: 'active',
      payment_method: formData.payment_method,
      transaction_ref: formData.transaction_ref || `TXN-${Date.now()}`,
    }

    const { error } = isUpdate
      ? await supabase.from('subscriptions').update(payload).eq('id', existingSubscription.id)
      : await supabase.from('subscriptions').insert(payload)

    if (error) { setError(error.message); setSaving(false); return }
    onRefresh()
    onClose()
  }

  const inputClass = "bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-white/10 focus:border-green-600 text-gray-900 dark:text-white px-4 py-3 text-sm outline-none transition-colors w-full"
  const labelClass = "text-xs text-gray-500 uppercase tracking-widest font-semibold"

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-4">
      <div className="bg-white dark:bg-gray-950 border border-gray-200 dark:border-white/10 p-8 w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="font-black text-xl uppercase tracking-tight text-gray-900 dark:text-white">
              {isUpdate ? 'Update Payment' : 'Record Payment'}
            </h2>
            <p className="text-gray-500 text-xs mt-1">{member.full_name} — {member.membership_id}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">✕</button>
        </div>

        {isUpdate && (
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800/50 text-blue-600 dark:text-blue-400 px-4 py-3 text-sm mb-4">
            Updating existing subscription record
          </div>
        )}
        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-red-600 dark:text-red-400 px-4 py-3 text-sm mb-4">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Amount ({currency})</label>
            <input type="number" value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: e.target.value })} required min="0" className={inputClass} />
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Payment Method</label>
            <select value={formData.payment_method} onChange={(e) => setFormData({ ...formData, payment_method: e.target.value })} className={inputClass}>
              <option value="cash">Cash</option>
              <option value="mobile_money">Mobile Money</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="card">Card</option>
            </select>
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Transaction Reference (optional)</label>
            <input type="text" value={formData.transaction_ref} onChange={(e) => setFormData({ ...formData, transaction_ref: e.target.value })} placeholder="e.g. MM-123456" className={inputClass} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <label className={labelClass}>Payment Date</label>
              <input type="date" value={formData.payment_date} onChange={(e) => setFormData({ ...formData, payment_date: e.target.value })} required className={inputClass} />
            </div>
            <div className="flex flex-col gap-2">
              <label className={labelClass}>Valid Until</label>
              <input type="date" value={formData.valid_until} onChange={(e) => setFormData({ ...formData, valid_until: e.target.value })} required className={inputClass} />
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button type="button" onClick={onClose} className="flex-1 border border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/30 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors">Cancel</button>
            <button type="submit" disabled={saving} className="flex-1 bg-green-600 hover:bg-green-700 disabled:bg-green-900 text-white py-3 font-bold uppercase tracking-widest text-sm transition-colors">
              {saving ? 'Saving...' : isUpdate ? 'Update Payment' : 'Record Payment'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}